import { AppBar, Typography, Toolbar, IconButton } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import SearchIcon from "@material-ui/icons/Search";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SettingsIcon from "@material-ui/icons/Settings";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React from "react";
import { Link, withRouter, Redirect, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { MenuDrawer, CoreMenuDrawer } from "../components";
import { DEVICECLASS } from "../common";
import "../styles/navStyles.css";
import { isAndroid, isIOS, isIOS13 } from "react-device-detect";

let deviceClass = "appBar " + DEVICECLASS();


const Head = props => {
    const _h = useHistory();
    const handleBack = () => {
        if (props.location.prevLoc && props.location.prevData) {
            let _obj = {
                pathname: props.location.prevLoc,
                state: {
                    prevProps: props.location.prevData
                }
            };

            _h.replace(_obj);
        } else if (typeof props.history !== 'undefined') {
            props.history.goBack();
        } else {
            return false;
        }
    }

    if (props.auth) {
        const { iconOne, iconTwo, headerText, backgroundcolor } = props;
        // console.log('\nheader: ', props);

        const iconSelector = icon => {
            switch (icon) {
                case "menu":
                    return (
                        <MenuDrawer 
                            className="headerIcons firstButton margin-left-12"
                            edge="start"
                            aria-label="firstIcon"
                        />
                    );

                case "coreMenu":
                    return (
                        <CoreMenuDrawer 
                            className="headerIcons firstButton margin-left-12"
                            edge="start"
                            aria-label="firstIcon"
                        />
                    );

                case "back":
                    return (
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                            onClick={handleBack}
                        >
                            <ArrowBackIosIcon className="headerIcons" />
                        </IconButton>
                    )

                case "search":
                    return (
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                        >
                            <SearchIcon className="headerIcons" />
                        </IconButton>
                    );
                case "home":
                    return (
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                        >
                            <Link
                                to={{
                                    pathname: "/home"
                                }}
                            >
                                <HomeIcon className="headerIcons" />
                            </Link>
                        </IconButton>
                    );

                case "profile":
                    return (
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                        >
                            <Link
                                to={{
                                    pathname: "/profile"
                                }}
                            >
                                <AccountCircleIcon className="headerIcons" />
                            </Link>
                        </IconButton>
                    );

                case "settings":
                    return (
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                        >
                            <Link
                                to={{
                                    pathname: "/settings"
                                }}
                            >
                                <SettingsIcon className="headerIcons" />
                            </Link>
                        </IconButton>
                    );
                default:
                    return (
                        <IconButton
                            className="firstButton"
                            edge="start"
                            aria-label="firstIcon"
                        >
                            &nbsp;
                        </IconButton>
                    );
            }
        };

        return (
            <AppBar id="auau-header" className={deviceClass} position="static">
                <Toolbar>
                    {iconSelector(iconOne)}

                    <Typography className="title" variant="h6">
                        {headerText || "AUA University"}
                    </Typography>

                    {iconSelector(iconTwo)}
                </Toolbar>
            </AppBar>
        );
    } else {
        return null;
    }
};

const mapStateToProps = state => {
    const { auth } = state.auth;
    const { headerText, iconOne, iconTwo, backgroundcolor, coresectionmenu } = state.data;
    return { headerText, iconOne, iconTwo, auth, backgroundcolor, coresectionmenu };
};

const Header = connect(mapStateToProps)(withRouter(Head));

export { Header }
